var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse-item-content",class:{ 'active': _vm.currentItemIndex === _vm.thisIndex }},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.thisImage.url || '/svg/image_placeholder.svg',"alt":"thisImage.alt || ''"}})]),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }